import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { Vehicle, VehicleFilters, VehicleDataForm } from '../../models/Vehicle';

const useVehicleService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetVehicles, setFetchingGetVehicles] = useState(false);
    const [fetchingStoreVehicle, setFetchingStoreVehicle] = useState(false);
    const [fetchingEditVehicle, setFetchingEditVehicle] = useState(false);
    const [fetchingUpdateVehicle, setFetchingUpdateVehicle] = useState(false);
    const [fetchingDeleteVehicle, setFetchingDeleteVehicle] = useState(false);
    const [fetchingActiveVehicle, setFetchingActiveVehicle] = useState(false);

    const getVehicles = (filter: VehicleFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filter)
            .filter(([, value]) => value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = EndPoints.VEHICLES.GET_VEHICLES + '?' + queryString;

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetVehicles
        });
    };

    const storeVehicle = (vehicle: VehicleDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.VEHICLES.STORE_VEHICLE,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            body: vehicle,
            setFetching: setFetchingStoreVehicle
        });
    };

    const editVehicle = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.VEHICLES.EDIT_VEHICLE.replace(':id', id.toString()),
            setFetching: setFetchingEditVehicle
        });
    };

    const updateVehicle = (id: number, vehicle: VehicleDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.VEHICLES.UPDATE_VEHICLE.replace(':id', id.toString()),
            body: vehicle,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            setFetching: setFetchingUpdateVehicle
        });
    };

    const deleteVehicle = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.VEHICLES.DELETE_VEHICLE.replace(':id', id.toString()),
            setFetching: setFetchingDeleteVehicle
        });
    };

    const activeVehicle = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.VEHICLES.ACTIVE_VEHICLE.replace(':id', id.toString()),
            body: { active: active },
            setFetching: setFetchingActiveVehicle
        });
    };

    return {
        fetchingGetVehicles,
        fetchingStoreVehicle,
        fetchingEditVehicle,
        fetchingUpdateVehicle,
        fetchingDeleteVehicle,
        fetchingActiveVehicle,
        getVehicles,
        storeVehicle,
        editVehicle,
        updateVehicle,
        deleteVehicle,
        activeVehicle
    };
};

export default useVehicleService;
